module.exports = __webpack_public_path__ + "img/notary-journal_B09JR3CXCY.0496d48b.jpg";